import styled, { css } from "styled-components";

export const Container = styled.div`
  /* should refactor to header  */
  background: ${(props) => props.theme.common.primaryColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: calc(60px + env(safe-area-inset-top));
  padding: calc(10px + env(safe-area-inset-top)) 10px 10px;
  min-height: calc(60px + env(safe-area-inset-top));
  /* should refactor to header  */
  position: relative;
  z-index: 20;
  flex-shrink: 0;

  @media screen and (max-width: 900px) {
    height: auto;
    min-height: calc(60px + env(safe-area-inset-top));
  }

  .icon {
    color: ${(props) => props.theme.common.headerIconColor};
  }

  .search-icon {
    width: 30px;
    height: 30px;
  }
`;

export const BackButton = styled.button`
  display: none;
  margin-right: 4px;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: transparent;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  .icon {
    color: ${(props) => props.theme.common.headerIconColor};
  }

  @media screen and (max-width: 900px) {
    display: inline-flex;
    align-items: center;
  }
`;

export const ProfileTrigger = styled.button`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: inherit;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
`;

export const AvatarWrapper = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
`;

export const Avatar = styled.img`
  /* should refactor to avatar */
  border-radius: 50%;
  height: 100%;
  width: 100%;
  object-fit: cover;
  /* should refactor to avatar */

  &.avatar--group {
    transform: scale(1.15);
  }
`;

export const ProfileWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const profileStyles = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Name = styled.h2`
  color: ${(props) => props.theme.common.mainHeadingColor};
  font-size: 1rem;
  margin-bottom: 2px;

  ${profileStyles}
`;

export const Subtitle = styled.p`
  color: ${(props) => props.theme.common.subHeadingColor};
  font-size: 0.75rem;
  direction: rtl;
  text-align: right;
  unicode-bidi: isolate-override;
  display: block;

  ${profileStyles}
`;

export const Actions = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  .action-menus-wrapper {
    z-index: 20;
  }

  @media screen and (max-width: 900px) {
    margin-right: 10px;
  }
`;

export const actionStyles = css`
  margin-left: 25px;
  cursor: pointer;
`;

export const Action = styled.button`
  ${actionStyles}
`;
